export default function CategoryBadge({ category, theme }) {
  const bg = theme ? theme.tableHover : "#f1f5f9";
  const color = theme ? theme.textSub : "#475569";
  return (
    <span style={{ background: bg, color, fontSize: 11, padding: "3px 10px", borderRadius: 20 }}>
      {String(category || "")}
    </span>
  );
}
